function validateRole(formsList, role) {
  const nonCGform = ['U407','U047A', 'U688A'];

  const inclusiveRole = {
    lendermortgagee: [...nonCGform],
    neighbour: ['CG2010'],
    landlord: [...nonCGform, 'CG2011', 'CG2026'],
    municipality: [...nonCGform, 'CG2012'],
    parentcompany: [...nonCGform, 'CG2005'],
  }
    
  const exclusiveRole = {
    other : ['CG2012', 'CG2018'],
  }

  const role_ = role.replace(/[^a-zA-Z]+/g, '');
  let updatedFormList;

  if (Object.keys(inclusiveRole).includes(role_.toLowerCase())) {
    updatedFormList = formsList.filter((form) => {
        return ((inclusiveRole[role_.toLowerCase()]).includes(form.value.split('-')[0]))
    });
  } else if (Object.keys(exclusiveRole).includes(role_.toLowerCase())) {
    updatedFormList = formsList.filter((form) => {
        return (!(exclusiveRole[role_.toLowerCase()]).includes(form.value.split('-')[0]))
    }); 
  } else {
      updatedFormList = formsList;
  }

  return [...new Set(updatedFormList)];
}

export default validateRole;